// The only way the portal talks to the API. Same origin (/api), cookie session.

export class ApiError extends Error {
  constructor(message, { status, code, data } = {}) {
    super(message);
    this.status = status;
    this.code = code;
    this.data = data;
  }
}

/**
 * body: sent as JSON. file: a File/Blob sent as it is (its own Content-Type), for uploads.
 */
export async function api(path, { method = 'GET', body, file } = {}) {
  const res = await fetch(`/api${path}`, {
    method,
    credentials: 'same-origin',
    headers: file ? { 'Content-Type': file.type || 'application/octet-stream' } : body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: file || (body !== undefined ? JSON.stringify(body) : undefined),
  });
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok) {
    throw new ApiError(data?.error || `Request failed (${res.status})`, { status: res.status, code: data?.code, data });
  }
  return data;
}
